import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Table from "../../../../../core/pagination/datatable";
// import TooltipIcons from "../../../../../core/common/tooltip-content/tooltipIcons";
// import RefreshIcon from "../../../../../core/common/tooltip-content/refresh";
// import CollapesIcon from "../../../../../core/common/tooltip-content/collapes";
import CommonFooter from "../../../../../core/common/footer/commonFooter";
import { Edit, RotateCcw } from "feather-icons-react/build/IconComponents";
import Swal from "sweetalert2";
import EditDepartment from "./Edit";
import AddDepartment from "./Add";
import { Spin } from "antd";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ImageWithBasePath from "../../../../../core/img/imagewithbasebath";
import { ROLL_CALL_API_BASE_URL } from "../../RollCallConfig/RollCallConfig";
import { Switch } from "antd";

const RollcallDepartmentList = () => {
  const [editObj, setEditObj] = useState(null);
  const [tokenData, setTokenData] = useState(null);
  const [data, setData] = useState([]);
  const [superIdData, setSuperIdData] = useState(null);
  const [loading, setloading] = useState(false);
  const location = useLocation();
  const [perm, setPerm] = useState({
    Read: false,
    Write: false,
    Delete: false,
    Export: false,
  });
  const [showEdit, setShowEdit] = useState(false);
  const [showAdd, setShowAdd] = useState(false);

  useEffect(() => {
    const stored = sessionStorage.getItem("rollcall-permissions");
    if (!stored) return;

    const map = JSON.parse(stored);
    const path = location.pathname.slice(1);
    const perms = map[path];
    if (!perms) {
      navigate("/rollcall/dashboard");
      return;
    }
    if (perms) {
      setPerm({
        Read: perms.canRead,
        Write: perms.canWrite,
        Delete: perms.canDelete,
        Export: perms.canExport,
      });
    }
  }, []);

  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (tokenData && superIdData) {
      console.log("Token:", tokenData);
      console.log("SuperId:", superIdData);
    }
  }, [tokenData, superIdData]);

  const fetchDepartments = async () => {
    if (tokenData && superIdData) {
      setloading(true);
      try {
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/department/getdepartment?superid=${superIdData}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${tokenData}`,
            },
          },
        );
        const data = await response.json();

        if (data["status"]) {
          setData(data["ResultData"]);
        } else {
          console.error("Failed to fetch holidays:", response.statusText);
        }
      } catch (error) {
        console.error("Error fetching holidays:", error.message);
      } finally {
        setloading(false);
      }
    }
  };

  useEffect(() => {
    if (tokenData && superIdData) {
      fetchDepartments();
    }
  }, [tokenData, superIdData]);

  const filteredData = data
    .slice()
    .sort((a, b) => b.IsActive - a.IsActive)
    .filter((item) => item?.Name?.toLowerCase() || item?.Code?.toLowerCase());

  useEffect(() => {
    console.log("Updated DataSource:", filteredData);
  }, [filteredData]);

  const columns = [
    {
      title: " Department Name",
      dataIndex: "Name",
      sorter: (a, b) => (a?.Name || "").localeCompare(b?.Name || ""),
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Code",
      dataIndex: "Code",
      sorter: (a, b) => (a?.Code || "").localeCompare(b?.Code || ""),
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Total Members",
      dataIndex: "EmpCount",
      sorter: (a, b) => Number(a?.EmpCount || 0) - Number(b?.EmpCount || 0),
      render: (record) => (record ? record : "N/A"),
    },

    {
      title: "Status",
      dataIndex: "IsActive",
      sorter: (a, b) => (a?.IsActive ? 1 : 0) - (b?.IsActive ? 1 : 0),
      key: "IsActive",
      render: (isActive, record) => (
        <Switch
          checked={Boolean(isActive)}
          onChange={() => {
            handleDelete(record.DepartmentId);
          }}
          style={{
            transform: "scale(0.8)",
            transformOrigin: "left center",
          }}
        />
      ),
    },
  ];

  if (perm?.Write) {
    columns.push({
      title: "Action",
      dataIndex: "action",
      align: "center",
      render: (_, record) => (
        <div className="action-table-data d-flex justify-content-center">
          <div className="edit-delete-action">
            <Link
              className="me-2 p-2"
              onClick={() => {
                handelShowEdit(record);
              }}
            >
              <Edit className="feather-edit text-info" />
            </Link>
            {/* <Link
              className="confirm-text p-2"
              to="#"
              onClick={() => handleDelete(record.departmentid)}
            >
              <Trash2 className="feather-trash-2 text-danger" />
            </Link> */}
          </div>
        </div>
      ),
    });
  }

  const handelShowEdit = (record) => {
    setShowEdit(true);
    setEditObj(record);
  };

  const handleReload = () => {
    window.location.reload();
  };

  const handleDownloadExcel = () => {
    if (filteredData && filteredData?.length === 0) {
      return; // Don't download if there is no data
    }
    const wb = XLSX.utils.book_new();
    const wsData = filteredData?.map((item, index) => ({
      "S.No": index + 1,
      Name: item.Name || "N/A",
      Code: item.Code || "N/A",
      "Total Members": item.EmpCount || "N/A",
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "Department Data");
    XLSX.writeFile(wb, "Department_List.xlsx");
  };

  const generatePDF = () => {
    if (filteredData && filteredData?.length === 0) {
      return; // Don't download if there is no data
    }

    const doc = new jsPDF();
    doc.text("Department List", 14, 10);

    const tableColumn = ["S.No", "Name", "Code", "Total Members"];
    const tableRows = filteredData?.map((item, index) => [
      index + 1,
      item.Name || "N/A",
      item.Code || "N/A",
      item.EmpCount || "N/A",
    ]);

    doc.autoTable({ head: [tableColumn], body: tableRows });
    doc.save("Department_List.pdf");
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  const handleDelete = async (departmentid) => {
    if (tokenData) {
      Swal.fire({
        title: "Are you sure?",
        text: "This action cannot be undone!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Action it!",
        cancelButtonText: "No, cancel",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await fetch(
              `${ROLL_CALL_API_BASE_URL}portal/department/deletedepartment`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${tokenData}`,
                },
                body: JSON.stringify({ departmentid: departmentid }),
              },
            );

            const result = await response.json();
            if (result.status) {
              Swal.fire({
                title: "Success",
                text: "Department Action successfully",
                icon: "success",
              }).then(() => {
                fetchDepartments();
              });
            } else {
              Swal.fire(
                "Error",
                response.message || "Failed to delete department.",
                "error",
              );
            }
          } catch (error) {
            console.error("Error deleting department:", error);
            Swal.fire("Error", "Something went wrong.", "error");
          }
        }
      });
    }
  };

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/rollcall/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Departments
                    </h4>
                  </ol>
                </nav>
                <h6>Manage your departments</h6>
              </div>
            </div>
            <ul className="table-top-head">
              {perm?.Export && (
                <>
                  <li>
                    <OverlayTrigger placement="top" overlay={renderTooltip}>
                      <Link onClick={generatePDF}>
                        <ImageWithBasePath
                          src="assets/img/icons/pdf.svg"
                          alt="img"
                        />
                      </Link>
                    </OverlayTrigger>
                  </li>
                  <li>
                    <OverlayTrigger
                      placement="top"
                      overlay={renderExcelTooltip}
                    >
                      <Link
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        onClick={handleDownloadExcel}
                      >
                        <ImageWithBasePath
                          src="assets/img/icons/excel.svg"
                          alt="img"
                        />
                      </Link>
                    </OverlayTrigger>
                  </li>
                </>
              )}
              <li onClick={handleReload}>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
            {perm?.Write && (
              <div className="page-btn mb-3">
                <Link
                  to="#"
                  className="btn btn-success btn-sm"
                  // data-bs-toggle="offcanvas"
                  // data-bs-target="#offcanvasRightAddDepartment"
                  // aria-controls="offcanvasRightAddDepartment"
                  onClick={() => setShowAdd(true)}
                >
                  <i className="ti ti-circle-plus fs-4"></i>
                </Link>
              </div>
            )}
          </div>
          {perm.Read ? (
            <div className="card table-list-card">
              <div className="card-header d-flex align-items-center justify-content-between">
                <div className="search-set">
                  <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                    <div className="col-6 mb-2">
                      <label className="form-label"></label>
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <br />
              <div className="card-body">
                <div className="table-responsive">
                  {loading ? (
                    <div className="text-center my-4">
                      <Spin size="large"></Spin>
                      <p>Loading data...</p>
                    </div>
                  ) : (
                    <Table
                      columns={columns}
                      dataSource={filteredData}
                      pgno={true}
                    />
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="card">
              <div className="card-body d-flex justify-content-center">
                <h1>You dont have access to this page</h1>
              </div>
            </div>
          )}
        </div>
        <CommonFooter />
      </div>

      <AddDepartment
        isOpen={showAdd}
        fetchDepartments={fetchDepartments}
        onClose={() => setShowAdd(false)}
      />

      <EditDepartment
        editObj={editObj}
        isOpen={showEdit}
        fetchDepartments={fetchDepartments}
        onClose={() => setShowEdit(false)}
      />
    </div>
  );
};

export default RollcallDepartmentList;
